import React from "react";

// import Header from "../../components/LandingPage/Header";
import HomeNavbar from "../Navbar/HomeNavbar";
import { ScrollSpy } from "organism-react-scroll-nav";
import {
  Banner,
  Feature,
  Showcase,
  Testimonials,
  Technology,
  Pricing,
  Contact,
} from "dan-components";
import { Helmet } from "react-helmet";
import brand from "dan-api/dummy/brand";
import Services from "../../components/LandingPage/Services";
import Footer from "../../components/LandingPage/Footer";
import MainFooter from "../../components/LandingPage/MainFooter";
import OurFeaturtes from "../../components/LandingPage/OurFeatures";
import UpcomingActivity from "../../components/LandingPage/UpcomingActivity";
import ServicesIndex from "../../components/LandingPage/ServicesSection/ServicesIndex";
import TopNav from "../Navbar/TopNav";
import MainServices from "../../components/LandingPage/MainServices/MainServices";
import MainFeature from "../../components/LandingPage/MainServices/MainFeature";
import FeatureIndex from "../../components/LandingPage/MainServices/FeatureIndex";
import Resources from "../../components/LandingPage/Resources/Resources";
import ResourcesMain from "../../components/LandingPage/Resources/ResourcesMain";
import NewFooter from "../../components/LandingPage/NewFooter";

const Index = () => {
  const envFile = process.env.REACT_APP_VARIABLE_NAME;
  const title = brand.name + " Home";
  const description = brand.desc;
  const imagePreview = brand.image;

  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
        <meta property="og:image" content="/app/images/logo/ivplogo.png" />
        <meta property="twitter:title" content={title} />
        <meta property="twitter:description" content={description} />
        <meta property="twitter:image" content="/app/images/logo/ivplogo.png" />
      </Helmet>
      <section id="banner">
        {/* <Header /> */}
        {/* <TopNav /> */}
        <HomeNavbar />
        <Banner />
      </section>
      {/* <ScrollSpy id="news">
        <UpcomingActivity />
      </ScrollSpy>
      <ScrollSpy id="feature">
        <Feature />
      </ScrollSpy> */}
      <ScrollSpy>
        <div id="services">
          <MainServices />
        </div>

        {/* <MainFeature /> */}
      </ScrollSpy>
      {/* <ScrollSpy> */}
      {/* <Resources /> */}
      {/* <ResourcesMain /> */}
      {/* <FeatureIndex /> */}
      {/* </ScrollSpy> */}
      {/* <ScrollSpy>
        <Services />
        <ServicesIndex />
      </ScrollSpy> */}
      {/* <ScrollSpy>
        <OurFeaturtes />
      </ScrollSpy> */}
      {/* <ScrollSpy id="showcase">
        <Showcase />
      </ScrollSpy>
      <ScrollSpy id="testimonials">
        <Testimonials />
      </ScrollSpy> */}
      {/* <ScrollSpy id="technology">
        <Technology />
      </ScrollSpy> */}
      {/* <ScrollSpy id="pricing">
        <Pricing />
      </ScrollSpy> */}
      {/* <ScrollSpy id="contact">
        <Contact />
      </ScrollSpy> */}
      <ScrollSpy>
        {/* <MainFooter /> */}
        <NewFooter />
      </ScrollSpy>
    </div>
  );
};

export default Index;
